<div class="d-flex flex-row col-md-12">
  <!-- TODO: Implement <rl-dropdown-single> -->
  <select aria-label="Workflow" class="form-select me-2" [(ngModel)]="chainedActionControl.value.processId"
    (ngModelChange)="getNextActions()" data-cy="workflowAction">
    <option value="null" selected>Select Workflow</option>
    @for (process of processes; track process) {
      <option [ngValue]="process.processID"
        [hidden]="omitChainedActionOption(process.processID + ' ' + process.processName)">{{ process.processID
      }} - {{ process.processName }}</option>
    }
  </select>
  <select aria-label="Action" class="form-select me-2" [(ngModel)]="chainedActionControl.value.nextActionId"
    data-cy="selectAction">
    <option value="null" selected>Select Action</option>
    @for (action of filteredNextActions; track action) {
      <option [ngValue]="chainedActionControl ? action.actionID : ''">
        {{ action.actionName }}
      </option>
    }
  </select>
</div>